module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Shovel-941ae76f666489f981256651218a89b8.svg";